module.exports = __webpack_public_path__ + "static/media/india-flag.ba8011c3.svg";